import React from "react";
import TransactionSub from "./TransactionSub";
import LedgerSub from "./LedgerSub";
import CardSub from "./CardSub";
import { useAppSelector } from "../../../redux/hook";

const GlobalSubListener = () => {
  const { company } = useAppSelector(
    (state) => state.information.myInformation,
  );
  const { clientId, paynovateId } = useAppSelector(
    (state) => state.ledger.myAccount,
  );
  return (
    <>
      <TransactionSub accountPaynovateId={paynovateId} />
      <LedgerSub clientId={company?.clientId ?? clientId} />
      <CardSub ledgerLinkcyId={""} />
    </>
  );
};

export default GlobalSubListener;
